/**
=========================================================
* ooGoal - v5.0.0
=========================================================

* Product Page: https://oogoal.com
* Copyright 2022 Onza Technologies

=========================================================

* The above copyright must be included
*/

import colors from "assets/theme/theme-dark/base/colors";
import pxToRem from "assets/theme/functions/pxToRem";

const { dark, transparent } = colors;

const select = {
  styleOverrides: {
    select: {
      display: "grid",
      alignItems: "center",
      padding: `0 ${pxToRem(12)} !important`,
      backgroundColor: transparent.main,

      "& .Mui-selected": {
        backgroundColor: dark.main,
      },
    },

    selectMenu: {
      background: dark.main,
      height: "none",
      minHeight: "none",
      overflow: "unset",
    },

    icon: {
      display: "none",
    },
  },
};

export default select;
